// extracted by mini-css-extract-plugin
module.exports = {"button":"_55-R","invert":"seyk","large":"eu3h","full":"Y2EK"};